import { createComponent } from '@carvana/merch-components';

export const FinanceContentContainer = createComponent('div', {
  className: 'flex gap-lg'
});

export const FinanceDetailsContainer = createComponent('div', {
  className: 'flex w-full flex-col justify-center gap-md'
});

export const FinanceTextGroup = createComponent('div', {
  className: 'flex flex-col gap-xs'
});

export const FinanceStatusMessage = createComponent('p', {
  className: 'text-text-strong t-strong-sm'
});

export const FinanceDetailsText = createComponent('p', {
  className: 'text-text-default t-body-sm'
});
